module.exports = __webpack_public_path__ + "img/imei_1000.e95ce446.jpg";